interface FacetResultTableBatchToolbarProps {
    isEditing: boolean;
    isSaving: boolean;
    onStartEdit: () => void;
    onSave: () => void;
    onCancel: () => void;
}

export default function FacetResultTableBatchToolbar({
    isEditing,
    isSaving,
    onStartEdit,
    onSave,
    onCancel,
}: FacetResultTableBatchToolbarProps) {
    if (!isEditing) {
        return (
            <div className="flex justify-end pb-2">
                <button
                    type="button"
                    onClick={onStartEdit}
                    disabled={isSaving}
                    className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-[12px] font-semibold text-slate-600 shadow-sm transition hover:bg-slate-50 disabled:opacity-50"
                >
                    Edit table
                </button>
            </div>
        );
    }

    return (
        <div className="flex justify-end gap-2 pb-2">
            <button
                type="button"
                onClick={onCancel}
                disabled={isSaving}
                className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-[12px] font-semibold text-slate-600 shadow-sm transition hover:bg-slate-50 disabled:opacity-50"
            >
                Cancel
            </button>
            <button
                type="button"
                onClick={onSave}
                disabled={isSaving}
                className="rounded-lg bg-indigo-600 px-3 py-1.5 text-[12px] font-semibold text-white shadow-sm transition hover:bg-indigo-700 disabled:opacity-50"
            >
                {isSaving ? "Saving…" : "Save changes"}
            </button>
        </div>
    );
}
